<template>
  <b-tab
    :title="title"
    :active="active"
    @click="$emit('handleClick', $event)"
  >
    <b-alert
      variant="info"
      lazy
      class="mb-0"
    >
      <div class="alert-body">
        <slot />
      </div>
    </b-alert>
  </b-tab>
</template>

<script>
import { BTab, BAlert } from 'bootstrap-vue'

export default {
    name: 'Tab',
    components: {
        BTab,
        BAlert,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            required: true,
        },
    },
}
</script>
